import { RootState } from '~/store';

export const buyAbonnementSelector = (state: RootState) => state.finance.buyAbonnement;
